export default {
  comparison: {
    aiCommand: {
      eyebrow: 'مركز قيادة الذكاء الاصطناعي Geofleet',
      title: 'أتمتة وكيلية من مركز قيادة واحد',
      intro:
        'بينما يتوقف آخرون عند الخرائط أو قواعد الإرسال البسيطة، يُنسّق مركز قيادة الذكاء الاصطناعي في Geofleet التخصيص التلقائي للناقلين، وتخصيص السائقين تلقائياً، والتخطيط الوكيلي للمسارات، والتنبيهات والإشعارات الذكية — مع وكلاء ذكاء اصطناعي يعملون نيابة عنك من برج تحكم واحد.',
      ctaFeatures: 'استكشف وكلاء الذكاء الاصطناعي والأتمتة',
      capabilities: {
        agents: {
          title: 'وكلاء الذكاء الاصطناعي',
          body: 'تنسق سير العمل الوكيلية في مركز القيادة الاستثناءات، وتعيد تعيين العمل، وتنسّق اللوجستيات متعددة المراحل دون انتظار مرسل بشري.',
        },
        carrier: {
          title: 'تخصيص الناقلين تلقائياً',
          body: 'يطابق الذكاء الاصطناعي كل شحنة مع الناقل المناسب حسب السعة والتكلفة واتفاقية مستوى الخدمة وتاريخ المسار والظروف الفورية — باستمرار.',
        },
        driver: {
          title: 'تخصيص السائقين تلقائياً',
          body: 'يُعاد تعيين السائقين وتوازنهم تلقائياً من نفس برج الناقلين، مع القرب والمهارات ونوبات العمل والحمولة في نموذج واحد.',
        },
        routes: {
          title: 'تخطيط مسارات وكيلي',
          body: 'تُخطَّط المسارات وتُعاد جدولتها بتعلم آلات يتفاعل مع الزحام والطلبات الجديدة والمحاولات الفاشلة وقيود المحاور.',
        },
        alerts: {
          title: 'تنبيهات وإشعارات بالذكاء الاصطناعي',
          body: 'تنبيهات استباقية لمخاطر اتفاقية مستوى الخدمة والتأخير وضغط السعة والاستثناءات — بأولوية ذكية لمعالجة الأهم أولاً.',
        },
        tower: {
          title: 'مركز قيادة واحد',
          body: 'كل شيء يعمل من مركز Geofleet واحد: دون تجميع أدوات معزولة للمسارات والإرسال والشركاء والاتصالات.',
        },
      },
    },
  },
};
